export default __webpack_public_path__ + "media/zurb/img/services/process/land-img-3afcf5d53849d965a44fc59e837bf961.png";